import TrezorBase from './Base.js';
import { TrezorDerivationPathType } from '../types.js';
export class TrezorBip44 extends TrezorBase {
    constructor(args) {
        super({
            ...args,
            derivationPathType: TrezorDerivationPathType.Bip44,
        });
    }
}
